import { Link } from 'react-router-dom';
import { Mail, Instagram, Facebook, MapPin, Phone } from 'lucide-react';
import logo2 from '../../assets/images/logo2.jpeg';

const Footer = () => {
    return (
        <footer className="bg-brand-dark text-white/60 pt-24 pb-12 border-t border-white/10">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 sm:gap-16 mb-20">
                    {/* Brand Column */}
                    <div className="lg:col-span-1">
                        <Link to="/" className="inline-block mb-8 group">
                            <div className="h-24 sm:h-28 w-auto overflow-hidden rounded-xl">
                                <img src={logo2} alt="SHOWROOM Logo" className="h-full w-auto object-contain transition-transform group-hover:scale-105" />
                            </div>
                        </Link>
                        <p className="text-sm leading-relaxed mb-8">
                            Redéfinir l'art de vivre contemporain à travers l'excellence sélectionnée. Nos pièces sont plus que des meubles ; ce sont des déclarations d'art et de savoir-faire.
                        </p>
                        <div className="flex items-center gap-4">
                            <a href="https://facebook.com" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-white hover:text-brand-dark transition-all group">
                                <Facebook className="w-4 h-4 text-white/60 group-hover:text-brand-dark" />
                            </a>
                            <a href="https://instagram.com" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-white hover:text-brand-dark transition-all group">
                                <Instagram className="w-4 h-4 text-white/60 group-hover:text-brand-dark" />
                            </a>
                            <Link to="/home" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-white hover:text-brand-dark transition-all group">
                                <svg viewBox="0 0 24 24" className="w-4 h-4 fill-white/60 group-hover:fill-brand-dark transition-colors" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.17-2.86-.6-4.12-1.31a6.38 6.38 0 0 1-2.22-2.02V15.5c0 1.26-.31 2.47-.92 3.53-.54.96-1.33 1.76-2.25 2.34a6.16 6.16 0 0 1-5.17.44 6.06 6.06 0 0 1-3.1-2.46 6.17 6.17 0 0 1-.95-3.57 6.18 6.18 0 0 1 1.14-3.66 6.13 6.13 0 0 1 3.41-2.45v4.09c-.98.28-1.81.93-2.3 1.83-.24.44-.36.94-.36 1.44 0 .34.06.67.17.98.28.81.93 1.49 1.74 1.81.31.11.64.17.98.17.66 0 1.28-.27 1.74-.74.47-.47.74-1.1.74-1.77V.02z" />
                                </svg>
                            </Link>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="text-white font-bold mb-8 uppercase tracking-widest text-xs">Collection</h4>
                        <ul className="space-y-4 text-sm">
                            <li><Link to="/" className="hover:text-brand transition-colors">Accueil</Link></li>
                            <li><Link to="/search?q=Salon" className="hover:text-brand transition-colors">Salon</Link></li>
                            <li><Link to="/search?q=Chambre" className="hover:text-brand transition-colors">Chambre à coucher</Link></li>
                            <li><Link to="/search?q=Salle%20de%20bain" className="hover:text-brand transition-colors">Salle de bain</Link></li>
                            <li><Link to="/search?q=Cuisine" className="hover:text-brand transition-colors">Cuisine</Link></li>
                            <li><Link to="/search?q=Divers" className="hover:text-brand transition-colors">Divers</Link></li>
                        </ul>
                    </div>

                    {/* Company */}
                    <div>
                        <h4 className="text-white font-bold mb-8 uppercase tracking-widest text-xs">Entreprise</h4>
                        <ul className="space-y-4 text-sm">
                            <li><Link to="/showroom" className="hover:text-brand transition-colors">Notre Histoire</Link></li>
                            <li><Link to="/showroom" className="hover:text-brand transition-colors">Showrooms</Link></li>
                            <li><Link to="/contact" className="hover:text-brand transition-colors">Contact</Link></li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="text-white font-bold mb-6 sm:mb-8 uppercase tracking-widest text-xs">Contactez-nous</h4>
                        <div className="space-y-4 sm:space-y-6 text-sm">
                            <div className="flex items-start gap-4">
                                <MapPin className="w-5 h-5 text-brand mt-0.5 shrink-0" />
                                <p>Marche bou bess<br />Guediawaye, Dakar</p>
                            </div>
                            <div className="flex items-start gap-4">
                                <MapPin className="w-5 h-5 text-brand mt-0.5 shrink-0" />
                                <p>Cite Apecsy<br />Yoff, Dakar</p>
                            </div>
                            <div className="flex items-center gap-4">
                                <Phone className="w-5 h-5 text-brand shrink-0" />
                                <p>78 138 74 74 (Guediawaye)</p>
                            </div>
                            <div className="flex items-center gap-4">
                                <Phone className="w-5 h-5 text-brand shrink-0" />
                                <p>71 140 68 06 (Yoff)</p>
                            </div>
                            <div className="flex items-center gap-4">
                                <Mail className="w-5 h-5 text-brand shrink-0" />
                                <p>contacts@keurfayeameublement.sn</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-6">
                    <p className="text-[10px] tracking-wider uppercase">
                        © 2026 KeurFayeAmmeublement. Tous droits réservés. Conçu pour l'Excellence.
                    </p>
                    <div className="flex items-center gap-8 text-[10px] tracking-wider uppercase">
                        <Link to="/home" className="hover:text-brand transition-colors">Politique de Confidentialité</Link>
                        <Link to="/home" className="hover:text-white transition-colors">Conditions d'Utilisation</Link>
                        <Link to="/home" className="hover:text-white transition-colors">Paramètres des Cookies</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
